import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-create-credit-note',
  templateUrl: './create-credit-note.component.html',
  styleUrls: ['./create-credit-note.component.scss']
})
export class CreateCreditNoteComponent implements OnInit {

 selectedBill = '';
  charges = [{
    service: '',
    quantity: 0,
    rate: 0,
    amount: 0,
  }];
  adjustmentAmount = 0;
  shipperInfo = '';
  note_date: any;
  chargeList = [
    "RTO charges",
    "Minimum Weight Gurrentied adjustment",
    "Multiple unloading point",
    "loading point other than JSP",
    "detention charges",
    "incentive",
  ];
  discountTypes = ['Fixed', 'Percent'];
  selectedDiscountType = 'Fixed';
  discountValue = 0;
  vendorBill: any;
  subTotalAmount = 0;
  totalAmount = 0;
  remarks = '';
  discountedAmount = 0;
  referenceNo: any = '';
  narration: any = '';
  noteType: any = '';
  noteDate: any;
  constructor(@Inject(MAT_DIALOG_DATA) private parentData: any, private http: HttpService, private snackBar: SnackbarService, private dialog: MatDialogRef<CreateCreditNoteComponent>) {}

  ngOnInit(): void {
    this.noteType = this.parentData.noteType;
    console.log("🚀 ~ file: create-credit-note.component.ts:48 ~ CreateCreditNoteComponent ~ ngOnInit ~ this.parentData:", this.parentData)
    const { shipper, IINC, item, customInvoiceNumber } = this.parentData;
    this.shipperInfo = item.shipper.name;
    this.vendorBill = customInvoiceNumber || '';
  }
  addCharge() {
    this.charges.push({
      service: '',
      quantity: 0,
      rate: 0,
      amount: 0,
    });
  }
  removeCharge(index) { 
    this.charges.splice(index, 1);
  }
  calculateTotal(i) {
    this.charges[i].amount = this.charges[i].quantity * this.charges[i].rate;
    this.subTotalAmount = this.charges.reduce((a, b) => a + Number(b.amount), 0);
  }

  calculateDiscount() {
    if (this.selectedDiscountType === 'Fixed') this.discountedAmount = this.discountValue;
    else if (this.selectedDiscountType === 'Percent') this.discountedAmount = (this.subTotalAmount * this.discountValue / 100);
    this.totalAmount = this.subTotalAmount - this.discountedAmount;
    if (this.adjustmentAmount) this.calculateAdjustedAmount();
  }
  calculateAdjustedAmount() {
    this.totalAmount = this.subTotalAmount  - this.discountedAmount + this.adjustmentAmount;
  }

  createDebitNote() {
    const payload = {
      invoice_ids: [this.parentData._id],
      type: 'Debit',
      narration: this.narration,
      line_items: this.charges.filter(a => a.amount !== 0).map(a => {
        return {
          reference_id: a.service,
          quantity: a.quantity,
          rate: a.rate,
          value: a.amount,
          comment: 'testing'
        }
      }),
      reference_no: this.referenceNo,
      remarks: this.remarks,
      discountType: this.selectedDiscountType,
      discount: this.discountedAmount,
      adjustmentAmount: this.adjustmentAmount,
      totalAmount: this.totalAmount,
      noteCreatedDate: this.noteDate,
      fromInvoice: false,
    };
    
    this.http.post('carrier_note/create_note', payload, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Debit Note Created Successfully', '');
          this.dialog.close();
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }
  createCreditNote() {
    const payload = {
      invoice_ids: [this.parentData._id],
      type: 'Credit',
      narration: this.narration,
      line_items: this.charges.filter(a => a.amount !== 0).map(a => {
        return {
          reference_id: a.service,
          quantity: a.quantity,
          rate: a.rate,
          value: a.amount,
          comment: 'testing'
        }
      }),
      reference_no: this.referenceNo,
      remarks: this.remarks,
      discountType: this.selectedDiscountType,
      discount: this.discountedAmount,
      adjustmentAmount: this.adjustmentAmount,
      totalAmount: this.totalAmount,
      noteCreatedDate: this.noteDate,
      fromInvoice: false,
    };
    
    this.http.post('carrier_note/create_note', payload, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Credit Note Created Successfully', '');
          this.dialog.close();
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }

  setDateTime(value) {
    const t1 = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy 00:00:00');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy 00:00:00'); // get the epoch time
     this.noteDate = epoch.ts;
  }
}
